module.exports = __webpack_public_path__ + "static/media/studio_logo.f642737b.png";